<form [formGroup]="formGroup" (ngSubmit)="save()">
  <div class="modal-header">
    <div class="modal-title h5" id="modalTitle">
      {{ viewMode === ViewMode.Create ? "Create database connection" : viewMode === ViewMode.View ? "View database connection details" : "Edit database connection" }}
    </div>
    <button type="button" class="close" (click)="activeModal.dismiss()" aria-label="Close modal?"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body">
    @if (errorMessage) {
    <alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
      <coso-alert-message>
        <div class="d-inline" [innerHTML]="errorMessage"></div>
      </coso-alert-message>
    </alert>
    }
    <p class="text-muted">
      <small><em>All fields are required unless specified optional</em></small>
    </p>
    <div class="form-group row">
      <div class="col-md-12 col-lg-5">
        <button
          type="button"
          name="authenticationType"
          class="btn d-block d-sm-inline-block"
          [class.btn-primary]="formGroup.controls.isSqlServer.value === false"
          [class.btn-secondary]="formGroup.controls.isSqlServer.value === true"
          (click)="onSQLiteClick()"
          [disabled]="viewMode === ViewMode.View"
        >
          SQLite
        </button>
        <button
          type="button"
          name="authenticationType"
          class="btn d-block d-sm-inline-block"
          [class.btn-primary]="formGroup.controls.isSqlServer.value === true"
          [class.btn-secondary]="formGroup.controls.isSqlServer.value === false"
          (click)="onSqlServerClick()"
          [disabled]="viewMode === ViewMode.View"
        >
          SQL Server
        </button>
      </div>
    </div>
    <coso-text-input
      [control]="formGroup.controls.databaseConnectionHolder.controls.name"
      [inputText]="formText.databaseConnectionHolder.name"
      [readonly]="viewMode === ViewMode.View"
    ></coso-text-input>
    @if (formGroup.controls.isSqlServer.value === true) {
    <coso-text-input [control]="formGroup.controls.serverName" [inputText]="formText.serverName" [readonly]="viewMode === ViewMode.View"></coso-text-input>
    <coso-text-input [control]="formGroup.controls.catalog" [inputText]="formText.catalog" [readonly]="viewMode === ViewMode.View"></coso-text-input>
    <coso-checkbox-input [control]="formGroup.controls.windowsAuthentication" [inputText]="formText.windowsAuthentication" [readonly]="viewMode === ViewMode.View"></coso-checkbox-input>
    @if (formGroup.controls.windowsAuthentication.value === false) {
    <coso-text-input [control]="formGroup.controls.username" [inputText]="formText.username" [readonly]="viewMode === ViewMode.View"></coso-text-input>
    <coso-text-input type="password" [control]="formGroup.controls.password" [inputText]="formText.password" [readonly]="viewMode === ViewMode.View"></coso-text-input>
    }
    <coso-checkbox-input [control]="formGroup.controls.encryptConnection" [inputText]="formText.encryptConnection" [readonly]="viewMode === ViewMode.View"></coso-checkbox-input>
    <coso-checkbox-input [control]="formGroup.controls.trustServerCertificate" [inputText]="formText.trustServerCertificate" [readonly]="viewMode === ViewMode.View"></coso-checkbox-input>
    } @else {
    <coso-text-input [control]="formGroup.controls.sqlLiteFilePath" [inputText]="formText.sqlLiteFilePath" [readonly]="viewMode === ViewMode.View"></coso-text-input>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-{{ viewMode !== ViewMode.View ? 'secondary' : 'primary' }}" (click)="activeModal.dismiss()">{{ viewMode !== ViewMode.View ? "Cancel" : "Close" }}</button>
    @if (viewMode !== ViewMode.View) {
    <button type="submit" class="btn btn-primary" [disabled]="formGroup.invalid">Save</button>
    }
  </div>
</form>

<ng-template #sqliteForm>
  <coso-text-input [control]="formGroup.controls.sqlLiteFilePath" [inputText]="formText.sqlLiteFilePath" [readonly]="viewMode === ViewMode.View"></coso-text-input>
</ng-template>

<ng-template #sqlLiteFilePathPopover>
  <p>The location of SQLite database file. If it does exist, it will be used. Otherwise, one will be created.</p>
  Examples:
  <ul>
    <li><i>C:\paper_system\sqlite3.db</i></li>
  </ul>
</ng-template>
